import { Gtm } from '../gtmClass';

export class MissionGtm extends Gtm {
  /** 미션 페이지 방문 */
  visit_mission_page() {
    this.track('visit_mission_page', { path: this.path });
  }
}
